import '../../src/app/scss/resource_centre.scss'

const RESEARCHAREAS = ['微生物', '环境', '植物', '微生物组', '动物', '人类遗传学', '临床研究', '癌症', '群体遗传学', 'covid-19/sars-cov-2'];
const TYPES = ['视频', '研究案例', '文献手册', '白皮书', '科研海报'];

document.addEventListener("DOMContentLoaded", () => {
  const resourceCenter = document.querySelector('.resource-centre');
  resourceCenter.searchIndex = {
    index: 'cws_chinese_resources_zh-hans',
    filters: ['type', 'channel', 'tags', 'authors'],
    domain: 'nanoporetech.com',
    hitsPerPage: 20
  };
  resourceCenter.filters = ['NOT tags:\'No video\''];
  resourceCenter.addEventListener('nanoDidLoad', () => {  
    resourceCenter
      .tplEngine
      .filters
      .define("intlDate",
        function( str, locale, options ) {
          if (!str) { return; }
      
          locale = locale || 'en-gb';
          options = options || { year: 'numeric', month: 'long', day: 'numeric' };
      
          let date = new Date(parseInt(str) * 1000);
          str = date.toLocaleDateString(locale, options);
          return str;
      }
    );
  });
  // breadcrumb
  const breadCrumb = document.querySelector('.breadcrumb');
  const breadCrumbBk = document.querySelector('.breadcrumb-bk');
  const breadCrumbSlash = document.querySelector('.breadcrumbs-slash');
  const breadCrumbTitle = document.querySelector('.breadcrumb-title');
  // search meta / context
  const contextEle = document.querySelector('.context-type');
  const searchInput = document.querySelector('.search-input');
  // filters
  const typeFilter = document.querySelector('.type-filter');
  const sectionFilter = document.querySelector('.section-filter');
  const tabsgroup = document.querySelector('.tabsgroup');

  breadCrumbBk.addEventListener('click', () => {
    sectionFilter.value = '';
  });

  const tagClick = (e) => {
    e.preventDefault();
    let tagVal = e.target.dataset.value;
    switch (tagVal) {
      case 'publication':
        tagVal = '发表文献'
        break;
      case 'video':
        tagVal = '视频'
        break;
      case 'white_paper':
        tagVal = '白皮书'
        break;
      case 'case_study':
        tagVal = '研究案例'
        break;
      case 'literature':
        tagVal = '文献手册'
        break;
      case 'poster':
        tagVal = '科研海报'
        break;
      case 'guide':
        tagVal = '指南'
        break;
      case 'flexible':
        tagVal = '资源库'
        break;
      default:
        tagVal = tagVal
    }
    tagVal = tagVal.toLowerCase()

    if (RESEARCHAREAS.includes(tagVal)) {
      sectionFilter.value = tagVal;
    } else if (TYPES.includes(tagVal)) {
      tabsgroup.show(tagVal);
    } else {
      const filter = document.querySelector('.resource-centre__filters nano-algolia-filter[filter-name="tags"]');
      if (filter.value.indexOf(tagVal) === -1) {
        filter.value = filter.value ? [...filter.value, tagVal] : [tagVal];
      }
    }
    setTimeout(_ => resourceCenter.scrollIntoView(true), 500);
  }

  const orderChange = (e) => {
    resourceCenter.replicaIndex = e.detail.value;
  }

  const removeFilter = (facet, filter) => {
    resourceCenter.removeFilters(facet, filter);
  }

  const attachResultListeners = (e) => {
    let context = resourceCenter;
    if (e) context = e.target;

    const tags = Array.from(
      context.querySelectorAll('.resource-centre__tags-tag')
    );

    tags.forEach(tag => {
      tag.removeEventListener('click', tagClick);
      tag.addEventListener('click', tagClick);
    });

    context.querySelectorAll('.resource-centre__remove-filter').forEach(item => {
      item.addEventListener('click', (e) => {
        let filter = e.target;
        removeFilter(filter.dataset.filter, filter.dataset.filterVal);
      })
    });

    const orderChangeSelect = context.querySelector('.order-change');
    if (orderChangeSelect) {
      try { orderChangeSelect.removeEventListener('nanoChange', orderChange); }
      catch(e) {}
      orderChangeSelect.addEventListener('nanoChange', orderChange);
    }

    context.querySelectorAll('.resource-centre__search-bk').forEach(item => {
      item.addEventListener('click', () => {
        resourceCenter.query = '';
        document.querySelector('.resource-centre__search-input').value = '';
      })
    })
  };

  const attachDynListeners = () => {
    const reset = document.querySelector('.resource-centre__filters-reset');
    const filters = Array.from(
      document.querySelectorAll('.resource-centre__filters nano-algolia-filter')
    );

    const resultsEles = Array.from(
      resourceCenter.querySelectorAll('nano-algolia-results')
    );

    resultsEles.forEach(resultEle => {
      resultEle.removeEventListener('nanoTplUpdated', attachResultListeners);
      resultEle.addEventListener('nanoTplUpdated', attachResultListeners);
    });
    attachResultListeners();

    reset.addEventListener('click', (e) => {
      filters.forEach((filter) => (filter.value = ''));
    });
  };

  resourceCenter.addEventListener('nanoResultsShown', (e) => {
    attachDynListeners();
  });

  resourceCenter.addEventListener('nanoFilterChanged', (e) => {
    const rhsFilters = document.querySelector('.resource-centre__filters');
    const sectionBtn = document.querySelector('nano-dropdown span .sections__title');
    const sectionDd = document.querySelector('nano-dropdown nano-icon.sections__btn--dd');
    const sectionClear = document.querySelector('.sections__btn--clear');

    if (sectionClear) {
      sectionClear.addEventListener('click', (e) => {
        e.stopPropagation();
        sectionFilter.value = '';
      })

    };

    if (sectionFilter.value.length) {
      let sectionTitle;
      try { sectionTitle = sectionFilter.value.join(' / '); }
      catch(e) { sectionTitle = sectionFilter.value }

      sectionBtn.innerHTML = sectionBtn ? sectionTitle : null;
      sectionClear.style.display = sectionClear ? 'block' : 'none';
      sectionDd.style.display = sectionDd ?  'none' : 'block';

      breadCrumbTitle.innerHTML = sectionTitle;
      breadCrumb.style.visibility = 'visible';
      breadCrumbSlash.innerHTML = ' /';
      breadCrumbBk.style.visibility = 'visible';
    } else {
      sectionBtn.innerHTML = sectionBtn ? '选择研究领域' : null;
      sectionClear.style.display = sectionClear ? 'none' : 'block';
      sectionDd.style.display = sectionDd ?  'block' : 'none';

      breadCrumbTitle.innerHTML = '资源中心';
      breadCrumb.style.visibility = 'hidden';
      breadCrumbSlash.innerHTML = '';
      breadCrumbBk.style.visibility = 'hidden';
    }

    if (typeFilter.value.length) {
      let typeTitle;
      try { typeTitle = typeFilter.value.join(' / '); }
      catch(e) { typeTitle = typeFilter.value }
      contextEle.innerHTML = typeTitle;
      if (typeFilter.value.includes('brochures') && !!rhsFilters) {
        rhsFilters.style.display = 'none';
      } else if (!!rhsFilters)  rhsFilters.style.display = 'block';
    } else {
      contextEle.innerHTML = '搜索';
      if (!!rhsFilters)  rhsFilters.style.display = 'block';
    }

    let placeholderStr = sectionFilter.value.length ? sectionFilter.value.join(' / ') : (typeFilter.value.length ? '' : '整个资源中心');

    placeholderStr += typeFilter.value.length ? '' + typeFilter.value.join(' / ') : '';
    searchInput.placeholder = '搜索' + placeholderStr;

  });

  const setPrimaryFilters = (filters) => {
    typeFilter.value = filters;
  };

  tabsgroup.addEventListener('nanoTabShow', (e) => {
    if (e.detail.name === 'all') setPrimaryFilters('');
    else setPrimaryFilters(e.detail.name.split('_').join(' '));
  });

  tabsgroup.addEventListener('click', (e) => {
    let target = e.target;
    if (target.tagName.toLowerCase() !== 'button') return;
    e.preventDefault();
    if (target.dataset && target.dataset.filter) {
      setPrimaryFilters(target.dataset.filter);
    }
  });
});
